import { create } from "zustand";
import { persist } from "zustand/middleware";

interface BranchFilterState {
  branchId: string | null;
  setBranch: (id: string | null) => void;
}

export const useBranchFilterStore = create<BranchFilterState>()(
  persist(
    (set) => ({
      branchId: null,
      setBranch: (id) => set({ branchId: id }),
    }),
    {
      name: "trainer-admin-branch-filter",
    },
  ),
);
